module.exports = require('../../full/symbol/iterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/features/symbol/iterator.js
// module id = 432
// module chunks = 0 1